import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { first } from 'rxjs/operators';

import { DnPerformanceService, AuthenticationService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dn-performance',
  templateUrl: './dn-performance.component.html'
})
export class DnPerformanceComponent implements OnInit {

  dnPerformances = [];
  headingValues = [];
  labelArray = [];
  keywordList: any = [];
  affiliateList = [];
  shortCodeList = [];
  shortCodeMapper = {};
  sourceList = [];
  countryList: any = {};
  lineChartData: Array<any>;
  lineChartSuccessData: Array<any>;
  lineChartSuccessRateData: Array<any>;
  lineChartLabels: Array<any>;
  lineChartColours: Array<any>;
  colors: Array<any> = ['lightblue', 'lightgreen', 'red', 'orange', 'yellow', 'black', 'darkgreen ', 'brown', 'purple', 'darkorange', 'darkblue',
    'darkred', 'green', 'lightorange', 'lightred']
  loading = false;
  processing = false;
  totalItems = 0;
  emptyResult = true;
  exporting = false;
  active = 1;
  //filter
  filterable = {
    shortCode: null,
    from: null,
    keyword: null,
    affiliate: '',
    to: null,
    source: null,
    country: null,
    realtime: false
  };

  downloadUrl = '';
  selectedCountry = '';
  allShortCodes = [];
  targetShortCode = null;

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  constructor(private fb: FormBuilder,
    private keywordSvc: KeywordService,
    private authSvc: AuthenticationService,
    private dnPerfomanceSvc: DnPerformanceService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadSources();
    // this.loadPage();
    this.loadAllShortCodes();
  }

  search() {
    this.loadPage();
  }

  onClear() {
    this.filterable.keyword = null;
    this.filterable.shortCode = null;
    this.filterable.affiliate = '';
    this.filterable.realtime = false;
    this.keywordList = [];
    this.affiliateList = [];
  }

  export() {
    this.exporting = true;
    var from = formatDate(this.filterable.from, 'yyyyMMdd', 'en');
    var to = formatDate(this.filterable.to, 'yyyyMMdd', 'en');
    let params = {
      from: from,
      to: to,
      source: this.filterable.source.value,
      country: this.filterable.country,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null ? "" : this.filterable.keyword.keyword,
      affiliate: this.filterable.affiliate
    }

    this.dnPerfomanceSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  gotoTargetShortCode(targetShortCode){
    if(targetShortCode){
      let source = this.sourceList.find(it => {return it.value == targetShortCode.source});
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if(targetShortCode){
        targetCountry = targetShortCode.country;
      }else{
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.affiliate = '';
    this.keywordList = [];
    this.affiliateList = [];
    this.shortCodeList = [];
    if (country) {
      this.keywordSvc.getSelectionScKws(this.filterable.source.value, country).subscribe(data => {
        this.shortCodeMapper = data.data;
        this.shortCodeList = Object.keys(this.shortCodeMapper);
        if(targetShortCode){
          this.changeShortCode(targetShortCode.shortCode, targetShortCode);
        }
      });
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    this.filterable.keyword = null;
    this.filterable.affiliate = '';
    this.keywordList = [];
    this.affiliateList = [];
    if(shortCode){
      this.keywordList = this.shortCodeMapper[shortCode];
    }
    if(!targetShortCode){
      this.targetShortCode = this.allShortCodes.find(it => {return it.shortCode == this.filterable.shortCode && it.source == this.filterable.source.value});
    }
  }

  changeKeyword(keyword){
     this.filterable.affiliate = '';
     this.affiliateList = keyword.affiliates;
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source = currentSource;
      this.countryList = currentSource.subOptions;
      var key = Object.keys(currentSource.subOptions)[0];
      var value = currentSource.subOptions[key];
      this.selectedCountry = value;
      this.filterable.country = value;
      this.changeCountry(value);
    });
  }

  private loadAllShortCodes(){
    this.keywordSvc.allShortCodeWithoutOperatorForSelection().pipe(first()).subscribe(data => {
      if(data){
        this.allShortCodes = data.data;
      }
    });
  }

  private loadPage() {
    this.loading = true;
    this.dnPerformances = [];
    this.totalItems = 0;
    var from = formatDate(this.filterable.from, 'yyyyMMdd', 'en');
    var to = formatDate(this.filterable.to, 'yyyyMMdd', 'en');
    // get page of items from api
    let params = {
      from: from,
      to: to,
      source: this.filterable.source.value,
      country: this.filterable.country,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null? "" : this.filterable.keyword.keyword,
      affiliate: this.filterable.affiliate
    }
    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    this.dnPerfomanceSvc.getAll(params, this.filterable.realtime).pipe(first()).subscribe(data => {
      if (data.status !== null) {
        this.dnPerformances = data.data;
        this.headingValues = data.data[Object.keys(data.data)[0]];
        this.totalItems = data.data.length;
        var lineChart = [];
        var lineSuccessChart = [];
        var lineSuccessRateChart = [];
        var lineColors = [];
        var i = 0;
        for (var key of Object.keys(this.dnPerformances)) {
          var total = this.dnPerformances[key].map(data => data.total);
          var success = this.dnPerformances[key].map(data => data.success);
          var successRate = this.dnPerformances[key].map(function (data) {
            if (data.total > 0) {
              return ((data.success / data.total) * 100).toFixed(3);
            } else {
              return 0;
            }
          });
          lineChart.push({
            data: total,
            label: key
          });
          lineSuccessChart.push({
            data: success,
            label: key
          });
          lineSuccessRateChart.push({
            data: successRate,
            label: key
          })
          this.lineChartLabels = this.dnPerformances[key].map(data => data.day);
          lineColors.push({
            backgroundColor: 'transparent',
            borderColor: this.colors[i],
            pointBackgroundColor: 'white',
            pointBorderColor: this.colors[i],
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
          });
          i++;
        }
        this.lineChartData = lineChart;
        this.lineChartSuccessData = lineSuccessChart;
        this.lineChartSuccessRateData = lineSuccessRateChart;
        this.lineChartColours = lineColors;
        this.loading = false;
        this.emptyResult = false;
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There are no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Missing field");
      }
    });
  }
  // lineChart
  public lineChartOptions: any = {
    animation: false,
    responsive: true,
    tooltips: {
      mode: 'index'
    }
  };

  public lineChartLegend = true;
  public lineChartType = 'line';

  // events
  public chartClicked(e: any): void {
    // console.log(e); callback
  }

}
